import API from "@/api";

const SET_LIST = "SET_LIST";
const SET_PRELOADER = "SET_PRELOADER";
const SET_TOTALS_PAGINATION = "SET_TOTALS_PAGINATION";
const SET_CURRENT_PAGE = "SET_CURRENT_PAGE";
const SET_SORT = "SET_SORT";

export default {
  namespaced: true,

  state: {
    list: "",
    pagination: {
      current: 1,
      totalPages: 1,
      totalResults: 1
    },
    sort: "",
    preloader: false
  },

  actions: {
    async listAll({ state, commit }) {
      commit("SET_PRELOADER", true);

      try {
        let results = await API.Orders.index(
          state.pagination.current,
          state.sort
        );
        commit("SET_TOTALS_PAGINATION", results.meta);
        commit("SET_LIST", results.data);
      } catch (e) {
        throw e;
      }

      commit("SET_PRELOADER", false);
    },

    async getOrder({ state }, order_id) {
      try {
        return await API.Orders.show(order_id);
      } catch (e) {
        throw e;
      }
    },

    async createOnGateway({ state }, order_id) {
      try {
        await API.Orders.createOnGateway(order_id);
      } catch (e) {
        throw e;
      }
    },

    async checkIfCouponApplies({ state }, payload) {
      try {
        return await API.Orders.checkIfCouponApplies(payload);
      } catch (e) {
        throw e;
      }
    },

    async applyCoupon({ state }, payload) {
      try {
        return await API.Orders.applyCoupon(payload);
      } catch (e) {
        throw e;
      }
    },

    setCurrentPage({ commit, dispatch, state }, payload) {
      let pageNumber =
        typeof payload === "object" ? payload.pageNumber : payload;

      if (pageNumber === state.pagination.current) return;

      commit("SET_CURRENT_PAGE", pageNumber);
      dispatch("listAll");
    },

    setSort({ commit, dispatch }, payload) {
      commit("SET_SORT", payload);
      dispatch("listAll");
    }
  },

  mutations: {
    [SET_LIST](state, payload) {
      state.list = payload;
    },
    [SET_PRELOADER](state, payload) {
      state.preloader = payload;
    },
    [SET_TOTALS_PAGINATION](state, payload) {
      state.pagination.totalPages = payload.page_count;
      state.pagination.totalResults = payload.record_count;
    },
    [SET_CURRENT_PAGE](state, payload) {
      state.pagination.current = payload;
    },
    [SET_SORT](state, payload) {
      state.sort = payload;
    }
  },

  getters: {}
};



// WEBPACK FOOTER //
// ./src/store/modules/orders.js